import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
 @Input() title = 'Confirm Action';
  @Input() message = '';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() isDanger = false;
  @Input() isBindRequest = false;
  @Input() showCancel = true;
  @Input() isContactSupport = false;
  @Input() isHtml = false;
  @Input() showCloseIcon = false;
  @Input() compactActions = false;

  constructor(public activeModal: NgbActiveModal) {}

  confirm() {
    this.activeModal.close('confirm');
  }

  cancel() {
    this.activeModal.dismiss(false);
  }

  closeModal() {
    this.activeModal.dismiss('closed'); 
  }
}
